export let configFormData = [
    {
        key: 'professionId',
        type: 'select',
        rules: [],
        label: '专业',
        child: [
        ],
        placeholder: '请选择专业',
        required: true
    },
    {
        key: 'schemeId',
        type: 'select',
        rules: [],
        label: '关联计划',
        child: [
            
        ],
        placeholder: '请选择官网关联的联系计划',
        required: true
    },
   
    // getProfesionlist


    /**
     *     {
        key: 'school2',
        type: 'select',
        rules: [],
        label: '报名方式',
        child: [
            { id: 1, label: '团队式', value: 1 },
            { id: 2, label: '个人式', value: 2 }
        ],
        placeholder: '请选择学校',
        required: true
    },
    {
        key: 'school3',
        type: 'select',
        rules: [],
        label: '最小报名单位',
        child: [
            { id: 1, label: '学校机构', value: 1 },
            { id: 2, label: '专业院系', value: 2 }
        ],
        placeholder: '请选择学校',
        required: true
    },
    {
        key: 'school4',
        type: 'select',
        rules: [],
        label: '指导教师规则',
        child: [
            { id: 1, label: '允许重复', value: 1 },
            { id: 2, label: '不允许重复', value: 2 }
        ],
        placeholder: '请选择学校',
        required: true
    },
    {
        key: 'sport',
        type: 'select',
        multiple: true,
        rules: [],
        label: '选手报名字段设置',
        placeholder: '请输入',
        child: [
            { id: 1, label: '中文姓名', value: 1 },
            { id: 2, label: '英文姓名', value: 2 },
            { id: 3, label: '英文姓名', value: 3 }, { id: 4, label: '证件号码', value: 4 }, { id: 5, label: '手机号码', value: 5 }, { id: 6, label: '电子邮箱', value: 6 },
            { id: 7, label: '所属国籍', value: 7 },
            { id: 8, label: '服装尺码', value: 8 },
        ],
        required: true,
        trigger: 'blur',
        isShow: false

    },
     {
        key: 'userName',
        type: 'input',
        rules: [],
        label: '小组/人数上限',
        required: true
    },

     */

]